import { CircularProgress, CssBaseline } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import MesseRouter from "./MesseRouter";
import InspirationEditor from "./InspirationEditor";
import './styles/sceneEditorChanges.scss';

export function renderUI(container) {
  const mainSeller = APP.metadata.Basis[0];

  ReactDOM.render(
    <>
      {mainSeller && (
        <Router>
          <MesseRouter></MesseRouter>
        </Router>
      )}
    </>,
    container[0]
  );
}

export function renderInspirationEditorUI(container) {
  const mainSeller = APP.metadata.Basis[0];

  ReactDOM.render(
    <>
      {mainSeller && (
        <Router>
          <InspirationEditor></InspirationEditor>
        </Router>
      )}
    </>,
    container[0]
  );
}

export function renderLoading(container) {
  ReactDOM.render(
    <>
      <CssBaseline></CssBaseline>
      <Box
        sx={{
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <CircularProgress size="7em" />
      </Box>
    </>,
    container[0]
  );
}
